module.exports = __webpack_public_path__ + "static/JG0-8cd434a008094d5e91a42c8cce217a98.png";